import React, { FC, useCallback } from "react";

import { ISelectProps, Select } from "@/components/Select";
import { Text } from "@/components/Text";
import { fetchCodelist, ICodelist, IFetchCodelistParams } from "@/data/codelists";
import { codelistFactory, ICodelistFactoryProps, ReactSelectComponents } from "@/eworkitComponents";
import { useCodelistTranslation } from "@/hooks/Codelist";

export interface ICodelistGenericSelectParams extends IFetchCodelistParams {}

export interface ICodelistGenericSelectProps extends ICodelistFactoryProps<ISelectProps, ICodelist> {
  query: ICodelistGenericSelectParams;
}

const CodelistGenericSelectComponent = codelistFactory<ISelectProps, ICodelist, ICodelistGenericSelectParams>(
  fetchCodelist,
  Select,
);

export const CodelistGenericSelect: FC<ICodelistGenericSelectProps> = ({ filterAfterFetch, query, ...restProps }) => {
  const tCodelist = useCodelistTranslation();

  const p = {
    ...restProps,
    portalPlacement: "auto",
  };

  const translateValues = useCallback(
    (options: ICodelist[]) => {
      const translated = options.map(option => ({
        ...option,
        value: tCodelist(query.codelistName, option.code),
      }));

      return filterAfterFetch ? filterAfterFetch(translated) : translated;
    },
    [filterAfterFetch],
  );

  return (
    <CodelistGenericSelectComponent
      filterAfterFetch={translateValues}
      components={{
        MultiValueLabel: ({ children, ...props }) => {
          return (
            <ReactSelectComponents.MultiValueLabel {...props}>
              {tCodelist(query.codelistName, props.data.code)}
            </ReactSelectComponents.MultiValueLabel>
          );
        },
        SingleValue: ({ children, ...props }) => {
          return (
            <ReactSelectComponents.SingleValue {...props}>
              <Text size={props.selectProps.size}>{tCodelist(query.codelistName, props.data.code)}</Text>
            </ReactSelectComponents.SingleValue>
          );
        },
      }}
      searchParams={query}
      {...p}
    />
  );
};
